// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","twoColContainer":"_2FoPS17jiz_XZcSosYVj4j","leftColumn":"_2aDDoMvSfAAK_hG-0lld-_","accessMsg":"_1IyTdmVfXnYFNIBd289PvB","disclaimer":"_3MNTCBDIvULYziGmD920v-"};